
import React from 'react';
import { Button } from "@/components/ui/button";

interface LeagueTableControlsProps {
  viewType: 'all' | 'home' | 'away';
  timeType: 'fullTime' | 'halfTime';
  onViewTypeChange: (type: 'all' | 'home' | 'away') => void;
  onTimeTypeChange: (type: 'fullTime' | 'halfTime') => void;
}

export const LeagueTableControls: React.FC<LeagueTableControlsProps> = ({
  viewType,
  timeType,
  onViewTypeChange,
  onTimeTypeChange
}) => {
  return (
    <div className="flex flex-wrap gap-2 justify-between mb-4">
      <div className="flex gap-2">
        <Button
          variant={timeType === 'fullTime' ? 'default' : 'outline'}
          onClick={() => onTimeTypeChange('fullTime')}
          size="sm"
        >
          Full Time
        </Button>
        <Button
          variant={timeType === 'halfTime' ? 'default' : 'outline'}
          onClick={() => onTimeTypeChange('halfTime')}
          size="sm"
        >
          Half Time
        </Button>
      </div>
      <div className="flex gap-2">
        <Button
          variant={viewType === 'all' ? 'default' : 'outline'}
          onClick={() => onViewTypeChange('all')}
          size="sm"
        >
          All
        </Button>
        <Button
          variant={viewType === 'away' ? 'default' : 'outline'}
          onClick={() => onViewTypeChange('away')}
          size="sm"
        >
          Away
        </Button>
      </div>
    </div>
  );
};
